import { Card, ListManager, Paginator } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import useQuery from '@/hooks/useQuery'
import mistreatmentTypes from '@/services/api/mistreatmentTypes'
import osmIntegrations from '@/services/api/osmIntegrations'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { toast } from 'react-toastify'
import { LoadingOverlay } from './styles'

function SelectAssunto({ typeId, assunto, onAssuntoChanged }) {
  const [selecting, setSelecting] = useState(false)
  const [active, setActive] = useState(false)
  const query = useQuery()

  const { data, loading, error } = useAxiosRequest(
    osmIntegrations.assuntos, { ...query },
  )

  function close() {
    setActive(false)
  }

  async function onSelectAssunto(assuntoId) {
    try {
      setSelecting(true)
      const res = await mistreatmentTypes.changeOsmAssuntoId(typeId, assuntoId)
      toast.success('Assunto selecionado com sucesso')
      onAssuntoChanged(res.data)
      close()
    } catch (e) {
      toast.error(e?.message || 'Erro ao selecionar assunto')
    } finally {
      setSelecting(false)
    }
  }

  async function onRemoveAssunto() {
    try {
      setSelecting(true)
      const res = await mistreatmentTypes.clearOsmAssuntoId(typeId)
      toast.success('Assunto removido com sucesso')
      onAssuntoChanged(res.data)
      close()
    } catch (e) {
      toast.error(e?.message || 'Erro ao remover assunto da integração')
    } finally {
      setSelecting(false)
    }
  }

  function onClickRemove() {
    confirmAlert({
      title: 'Confirma a remoção da integração?',
      message: 'Esta ação irá remover o assunto da integração, mas não irá excluir o assunto do OS-m e nem as Ordens de Serviço já criadas com este assunto.',
      buttons: [
        { label: 'Não' },
        {
          label: 'Sim',
          className: 'bg-error',
          onClick: onRemoveAssunto,
        },
      ],
    })
  }

  function onClickRow(row) {
    if (Number(row.id) !== Number(assunto?.id)) {
      confirmAlert({
        title: 'Selecionar este assunto?',
        message: row.descricao,
        buttons: [
          { label: 'Não' },
          {
            label: 'Sim',
            className: 'bg-primary',
            onClick: () => onSelectAssunto(row.id),
          },
        ],
      })
    }
  }

  return (
    <>
      {
        selecting && (
          <LoadingOverlay>
            <Card.Base style={{ height: 'auto', width: 200 }}>
              <Card.Body>
                <div className="my-2">
                  <div>
                    <div className="loading loading-lg" />
                    <div className="mt-2 text-center">Aguarde</div>
                    <div className="text-center"><small>Estamos atualizando a integração</small></div>
                  </div>
                </div>
              </Card.Body>
            </Card.Base>
          </LoadingOverlay>
        )
      }
      <a className="no-decoration tooltip tooltip-top" data-tooltip="Selecionar assunto" onClick={() => setActive(true)}>
        <>
          <i className="fas fa-edit" />&nbsp;
          {
            assunto ? (
              <span>
                <span>#{assunto.id} - {assunto.descricao}</span>
              </span>
            ) : (
              <span>Selecionar assunto</span>
            )
          }
        </>
      </a>
      <div className={`modal ${active ? 'active' : ''}`}>
        <a type="button" className="modal-overlay" aria-label="Close" onClick={close} />
        <div className="modal-container">
          <div className="modal-header">
            <a
              type="button"
              className="btn btn-clear float-right"
              onClick={close}
            />
            <div className="modal-title h5">
              Selecionar assunto de OS-m
            </div>
          </div>
          <div className="modal-body">
            <div>Selecione o assunto de OS-m para este tipo de denúncia</div>
            {
              Boolean(assunto) && (
                <div className="my-2">
                  Assunto atual: <b>#{assunto.id} - {assunto.descricao}</b>
                  <a
                    onClick={onClickRemove}
                    data-tooltip="Remover assunto da integração"
                    className="btn btn-link text-error btn-sm btn-action tooltip tooltip-top mb-1"
                  >
                    <i className="fas fa-trash-alt" />
                  </a>
                </div>
              )
            }
            <ListManager count={data?.count ?? 0} loading={loading} error={error}>
              <small>
                <table className="table table-hover my-2">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Descrição</th>
                      <th width="1" className="text-right">Selecionado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      Boolean(data) && data.rows.map((row) => (
                        <tr key={row.id} className="c-hand" onClick={() => onClickRow(row)}>
                          <td>{row.id}</td>
                          <td>{row.descricao}</td>
                          <td className="text-right">
                            {
                              Number(assunto?.id) === Number(row.id) && (
                                <i className="fas fa-check text-primary" />
                              )
                            }
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </small>
              <Paginator paginatedList={data} />
            </ListManager>
          </div>
        </div>
      </div>
    </>
  )
}

SelectAssunto.propTypes = {
  typeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onAssuntoChanged: PropTypes.func.isRequired,
  assunto: PropTypes.objectOf(Object),
}

SelectAssunto.defaultProps = {
  assunto: null,
}

export default SelectAssunto
